/**
 * Girişin ikinci adımı — üç personel uygulamasının ortak ayrımı (C-03).
 *
 * ## Neden burada, üç mağazada değil
 *
 * POS, KDS ve işletme paneli aynı giriş ucunu çağırıyor ve üçü de aynı
 * cevabı yorumlamak zorunda. Ayrımı üç kopya hâlinde tutmak, birinde
 * düzeltilip diğerinde unutulacağı gün demekti — aktif işletme seçiminde
 * (B-16) tam olarak bu karar verilmişti ve gerekçesi aynı.
 *
 * ## `unauthenticated` ile KARIŞTIRILMAMALI
 *
 * Sunucu parola yanlışken `unauthenticated`, MFA gerekliyken
 * `mfa_code_required` dönüyor. İkisini tek "giriş yapılamadı" kovasına
 * atmak, kod alanını hiç göstermemek ve kullanıcıyı doğru parolayla kapalı
 * bir kapıda bırakmak olurdu.
 */

/** Sunucunun hata kodunu okur; `ApiError` sınıfına bağlanmıyor. */
function codeOf(failure: unknown): string | null {
  if (typeof failure !== 'object' || failure === null) {
    return null
  }

  const code = (failure as { code?: unknown }).code

  return typeof code === 'string' && code !== '' ? code : null
}

/**
 * Parola doğru ama ikinci adım gerekiyor.
 *
 * Bu bilgi parolayı bilen kişiye açılıyor ve açılması gerekiyor: istemcinin
 * kod alanını göstermesinin başka yolu yok.
 */
export function isMfaCodeRequired(failure: unknown): boolean {
  return codeOf(failure) === 'mfa_code_required'
}

/**
 * Girilen kod kabul edilmedi.
 *
 * TOTP mi kurtarma kodu mu olduğu sunucu tarafında da ayrılmıyor; ekran da
 * ayırmıyor.
 */
export function isMfaCodeInvalid(failure: unknown): boolean {
  return codeOf(failure) === 'mfa_code_invalid'
}

/** Ekranın kod alanını göstermesi gereken durumlar. */
export function needsMfaCode(failure: unknown): boolean {
  return isMfaCodeRequired(failure) || isMfaCodeInvalid(failure)
}
